import { AsYouType, parsePhoneNumber } from 'libphonenumber-js';

const BR_PHONE_PATTERN = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

const MX_PHONE_PATTERN = [/\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

const US_PHONE_PATTERN = [
  '(',
  /\d/,
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
];

export interface ICountryPhone {
  prefixNumber: string;
  code: string;
  mask?: any;
  placeHolder?: string;
}

const getPhoneInformationObject = (phoneNumber: string, phoneOptions: ICountryPhone) => {
  const countryCode = phoneOptions?.code || 'BR';
  const phone = new AsYouType(countryCode as any);
  phone.input(phoneNumber);
  return phone;
};

const defaultInitialPhoneValues = {
  prefixNumber: '+55',
  code: 'BR',
  mask: BR_PHONE_PATTERN,
  placeHolder: '(99) 99999-9999',
};

const getParsedPhoneDetails = (mobile_phone: string) => {
  if (!mobile_phone) return defaultInitialPhoneValues;
  try {
    const phone = parsePhoneNumber(mobile_phone);

    const phoneParams = {
      nationalNumber: phone.nationalNumber,
      code: phone.country,
      prefixNumber: `+${phone?.countryCallingCode}`,
      mask: BR_PHONE_PATTERN,
      placeHolder: '(99) 99999-9999',
    };

    if (phone.country === 'MX') {
      phoneParams.mask = MX_PHONE_PATTERN;
      phoneParams.placeHolder = '999 999 9999';
    }
    if (phone.country === 'US') {
      phoneParams.mask = US_PHONE_PATTERN;
      phoneParams.placeHolder = '(999) 999-9999';
    }

    return phoneParams;
  } catch (e) {
    return defaultInitialPhoneValues;
  }
};

export {
  BR_PHONE_PATTERN,
  MX_PHONE_PATTERN,
  US_PHONE_PATTERN,
  getParsedPhoneDetails,
  getPhoneInformationObject,
  defaultInitialPhoneValues,
};
